import { render } from "./CardUl.vue?vue&type=template&id=09bfe5fc"
import script from "./CardUl.vue?vue&type=script&lang=js"
export * from "./CardUl.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__